import { Serializer } from 'serialize-ts';

import { InvalidParams } from '../models/invalid-params.model';

export class InvalidParamsSerializer implements Serializer<InvalidParams> {
  public serialize(invalidParams: InvalidParams): InvalidParams {
    return invalidParams;
  }

  public deserialize(invalidParams = []): InvalidParams {
    return invalidParams.reduce((memo: InvalidParams, invalidParam) => {
      const { element, translation, ...otherInvalidParamProperties } = invalidParam;
      return {
        ...memo,
        [element.split('.').splice(-1)[0]]: {
          ...otherInvalidParamProperties,
          reason: translation
        },
      };
    }, {});
  }
}
